<template>
    <v-card>
        <v-card-title class="bg-title-card">
            <span class="white--text headline" v-text="tituloFormulario"></span>
        </v-card-title>
        <v-container>
            <v-form ref="form">
                <v-row dense>
                    <v-col cols="12">
                        <v-text-field label="Tipo Vehículo *" color="textbox" v-model="seleccionado.tipoVehiculo"
                            :rules="_.concat(requeridoRegla,soloLetrasRegla(3,seleccionado.tipoVehiculo,300))"
                            :counter="300" outlined dense />
                    </v-col>
                    <v-col cols="12">
                        <v-autocomplete label="Estado *" color="textbox" v-model="seleccionado.idEstado"
                            :rules="requeridoRegla" :items="listaEstadoModal" item-text="nombre_estado"
                            item-value="id_estado" outlined dense />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-spacer></v-spacer>
                    <v-col class="text-right">
                        <v-btn outlined rounded class="mr-1" color="danger" @click="cerrarFormulario(), $refs.form.resetValidation();">Cancelar</v-btn>
                        <v-btn rounded dark color="primary" @click="guardar()">Guardar</v-btn>
                    </v-col>
                </v-row>
            </v-form>
        </v-container>
    </v-card>
</template>

<script>
    export default {
        name: "ModalTipoVehiculoComponent",
        methods: {
            guardar() {
                if (this.$refs.form.validate()) {
                    this.insertarActualizar((this.seleccionado.idTipoVehiculo == null) ? "I" : 'U');
                    this.cerrarFormulario();
                    this.$refs.form.resetValidation();
                } else
                    mensajesAlerta(mensajeEstandar.corregirInformacion, 'I');
            },
        },
        computed: {
            listaEstadoModal() {
                var listadoEstadoModal = this.listaGeneral.estado;
                if (this.listaGeneral.estado) {
                    listadoEstadoModal = this.listaGeneral.estado.filter(estado => {
                        return estado.visualiza.toLowerCase().includes('true');
                    });
                    this.seleccionado.idEstado = (this.seleccionado.idEstado > "0") ? this.seleccionado.idEstado : '1';
                }
                return listadoEstadoModal;
            }
        },
        props: ['seleccionado', 'tituloFormulario', 'listaGeneral'],
        inject: ['insertarActualizar', 'cerrarFormulario'],
    }
</script>